<template >
<div>    
    <small class="ml-3 mr-4" style="font-size: 24px; color:green"> 
        <strong>
            <span style=" font-size: 20px;  color:black">SCONTO </span> 
            <span class="ml-3">{{ total_discount }} % </span>
        </strong>
    </small>
</div>    
</template>
<script>
        
    export default {
      props:['item'] , 
      
     data () {
        return {
               
        total_discount  : 0,
                
        }
      },
            
    mounted()
    {
       
        
    },  
    created()
    {
      
      
      this.total_discount = 0       
      this.setTotalDiscount()

    },
    methods : {
    setTotalDiscount()
    {
      
        const netTotal = Math.abs(this.item.netTotal)  
        const total = Math.abs(this.item.total)  
        if(Number(netTotal) > Number(total))
        {
          this.$emit('setDiscount',0)  
          return
        }
        const subTotal = (Number(netTotal) / total) * 100.00
        const total1 = 100.00 - subTotal
            
        this.total_discount = Number(total1.toFixed(2))        
        this.$emit('setDiscount',this.total_discount)
        
        
    },

}
}
    </script>
    <style scoped>

    </style>
    